import { render, staticRenderFns } from "./sale-product-by-group.vue?vue&type=template&id=6f1b232a&scoped=true&"
import script from "./sale-product-by-group.vue?vue&type=script&lang=js&"
export * from "./sale-product-by-group.vue?vue&type=script&lang=js&"
import style0 from "./sale-product-by-group.vue?vue&type=style&index=0&id=6f1b232a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b232a",
  null
  
)

export default component.exports